import { Facility } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

export const getFacilities = async (): Promise<Facility[]> => {
  const { data } = await queryBuilder('GET', 'facilities');
  return data;
};
